import { useConfig } from '@occc/config';
import { OfferSubtype } from '@occc-app/offerValidationService/types';
import { OfferFragment } from '@occc/graphql';

import { getAwardSubtype } from '../../AwardDetailsPage/utils';

export const useIsOrderAheadEnabled = (award: OfferFragment) => {
  const orderAheadConfig = useConfig('orderAheadConfig');
  const awardSubType = getAwardSubtype(award);

  const isOrderAheadEnabled =
    !!awardSubType &&
    orderAheadConfig.enabled &&
    orderAheadConfig.shouldShowDisplayForOrderAheadToggle &&
    [
      OfferSubtype.TransactionDiscount,
      OfferSubtype.ProductDiscount,
      OfferSubtype.ExternalFulfillment,
    ].includes(awardSubType);

  return isOrderAheadEnabled;
};
